export enum GroupingOptions {
  ByTask = 'byTask',
  ByMember = 'byMember',
  ByTimeBlock = 'ByTimeBlock',
}
